export enum DEVICES_STORAGE_KEYS {
  DealerPreference = "devices-dealer-preference",
  LocationPreference = "devices-location-preference",
  BrandsPreference = "devices-brands-preference",
  ModelsPreference = "devices-models-preference",
  OsVersionsPreference = "devices-os-versions-preference",
  OrderByPreference = "devices-order-by-preference",
  PageSizePreference = "devices-page-size-preference"
}
